import { render, staticRenderFns } from "./ipasasJaPermissionsForm.vue?vue&type=template&id=ab3a501e&scoped=true&"
import script from "./ipasasJaPermissionsForm.vue?vue&type=script&lang=js&"
export * from "./ipasasJaPermissionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3a501e",
  null
  
)

export default component.exports